(function () {
  const addTabsEvents = () => {
    const tabsWrapper = document.querySelector(".blog-tabs");
    const tabElements = document.querySelectorAll(".blog-tabs li");
    tabElements.forEach((tabElement) => {
      const tabBtn = tabElement.querySelector("a");
      tabBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        // Trigger section update
        const href = tabBtn.href;
        if (!tabElement.classList.contains("active")) {
          renderBlogsGrid(href);
        }

        resetActiveStates();
        tabElement.classList.add("active");
      });
    });
    // Scroll to selected element
    if (window.innerWidth <= 960) {
      const activeElement = document.querySelector(".blog-tabs li.active");
      activeElement.scrollIntoView();
      const yOffset = -100;
      const y =
        tabsWrapper.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({
        top: y,
        behavior: "instant",
      });
    }
  };

  addTabsEvents();

  const renderBlogsGrid = async (href) => {
    toggleOverlay("open");
    const sectionId = document
      .querySelector(".main-blog")
      .id.replaceAll("shopify-section-", "");
    let url = new URL(href);
    url.searchParams.append("section_id", sectionId);

    const res = await fetch(url.href);
    let html;
    if (res.ok) {
      html = await res.text();
      document.querySelector(".main-blog").innerHTML = html;
      addTabsEvents();
      url.searchParams.delete("section_id");
      history.pushState({}, "", url.href);
      toggleOverlay("close");
    }
  };

  const toggleOverlay = (state) => {
    const overlay = document.querySelector(".blog-overlay");
    if (state === "open") {
      overlay.classList.add("active");
    } else if (state === "close") {
      overlay.classList.remove("active");
    }
  };

  const resetActiveStates = () => {
    const tabElements = document.querySelectorAll(".blog-tabs li");
    tabElements.forEach((tabElement) => {
      tabElement.classList.remove("active");
    });
  };
})();
